import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const BonusChip = ({ disabled, selectedStatus, setSelectedStatus, status, statusMessage }) => {
  const itemClassName = cx('chips-item', { active: selectedStatus === status });

  const onClick = () => {
    if (status === selectedStatus) {
      setSelectedStatus(null);
      return;
    }
    setSelectedStatus(status);
  };

  return (
    <button className={itemClassName} disabled={disabled} onClick={onClick} type="button">
      <Label className="value" message={statusMessage ?? status} />
    </button>
  );
};

BonusChip.propTypes = {
  disabled: PropTypes.bool.isRequired,
  selectedStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  setSelectedStatus: PropTypes.func.isRequired,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  statusMessage: PropTypes.string,
};

export default BonusChip;
